import { useEffect } from 'react';
import { useAppDispatch } from '../store';
import { fetchAllTopics } from '../store/topics/slice';

export const useAppInit = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    // Fetch all topics at app startup
    dispatch(fetchAllTopics());
  }, [dispatch]);
};
